// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoCirCheckCircleFilledSvg from "@fishx/icons-svg/es/asn/PtoCirCheckCircleFilled";
import FishxIcon from '../components/FishxIcon';

var PtoCirCheckCircleFilled = function PtoCirCheckCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoCirCheckCircleFilledSvg
  }));
};

PtoCirCheckCircleFilled.displayName = 'PtoCirCheckCircleFilled';
export default React.forwardRef(PtoCirCheckCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoCirCheckCircleFilled.js
// module id = 3888
// module chunks = 0